module.exports = __webpack_public_path__ + "static/media/F-3.471c270c.webp";